import { automationTherapistResponse } from '@/modules/permissionsToogle/domain/models/automationTherapistResponse'

import { axios, Response } from '../index'

const updatePermissionGroup = (
  groupId: string
): Response<automationTherapistResponse> => {
  return axios.put(`/v1/automation-groups/${groupId}`, {
    automationTherapistId: groupId
  })
}
export default updatePermissionGroup
